import { components } from 'react-select';
import Icon from '@mdi/react';
import { mdiChevronDown } from '@mdi/js';

function CustomDropdownIndicator(props) {
  return (
    <components.DropdownIndicator {...props}>
      <Icon path={mdiChevronDown} size={0.8} color="#343A40" />
    </components.DropdownIndicator>
  );
}

export default CustomDropdownIndicator;
